import { DatePicker, DatePickerProps } from '@material-ui/pickers';
import React from 'react';
import styles from './SGSYearPicker.module.scss';
import { Box, IconButton } from '@material-ui/core';
import { ReactComponent as ChevronLeft } from 'assets/circle-chevron-left-thin.svg';
import { ReactComponent as ChevronRight } from 'assets/circle-chevron-right-thin.svg';
import { Controller, useFormContext } from 'react-hook-form'; // Import useForm and Controller
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

type Props = DatePickerProps & {
    onYearDecrement: () => void;
    onYearIncrement: () => void;
};

const SGSYearPicker: React.FC<Props> = ({ value, onYearDecrement, onYearIncrement, name = '', ...props }) => {
    const { control } = useFormContext();
    const { t } = useTranslation();

    return (
        <Box display="flex" justifyContent="center" alignItems="center" className={styles.yearpickerContainer}>
            <IconButton size="small" onClick={onYearDecrement} className={styles.arrow}>
                <ChevronLeft />
            </IconButton>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <DatePicker
                        name="Year"
                        variant="inline"
                        format="YYYY"
                        className={classNames('m-2')}
                        disableToolbar
                        {...field}
                        {...props}
                        value={value}
                        views={['year']}
                        autoOk={true}
                        cancelLabel={t('global.cancel')}
                        clearLabel={t('global.clear')}
                        okLabel={t('global.ok')}
                        todayLabel={t('global.today')}
                        InputProps={{
                            classes: {
                                root: styles.yearpickerInputContainer,
                            },
                        }}
                    />
                )}
            />
            <IconButton size="small" onClick={onYearIncrement} className={styles.arrow}>
                <ChevronRight />
            </IconButton>
        </Box>
    );
};

export default SGSYearPicker;
